module.exports = __webpack_public_path__ + "static/media/ic_com_reactivation.43ac1ae7.svg";